// Angular Imports
import {NgFor, NgIf} from '@angular/common'
import {ChangeDetectionStrategy, Component, ElementRef, inject, signal, ViewChild,} from '@angular/core'
// Shared Imports
import {ToolsService} from '@shared/services'
import {ButtonComponent, IconButtonComponent, IconComponent} from '@shared/components'
import {EIcons, FilePreview} from '@shared/models'

const sharedComponents = [ButtonComponent, IconComponent, IconButtonComponent]

@Component({
	standalone: true,
	selector: 'app-upload-images',
	imports: [NgIf, NgFor, ...sharedComponents],
	templateUrl: './upload-images.component.html',
	styleUrls: ['./upload-images.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadImagesComponent {
	readonly #tools = inject(ToolsService)
	readonly EIcons = EIcons
	@ViewChild('selectPhotoInput') selectPhotoInput!: ElementRef
	@ViewChild('takePhotoInput') takePhotoInput!: ElementRef

	files = signal<Array<File>>([])
	filesPreview = signal<Array<FilePreview>>([])

	allowedFileExtensions: Array<string> = ['png', 'jpg', 'jpeg', 'jfif', 'webp', 'heif']

	onSelectPhoto() {
		const inputElement: any = this.selectPhotoInput?.nativeElement
		inputElement.accept = 'image/*'
		inputElement.click()
	}

	onTakePhoto() {
		const inputElement: any = this.takePhotoInput?.nativeElement
		inputElement.capture = 'environment'
		inputElement.accept = 'image/*'
		inputElement.click()
	}

	async onHandleFile(event: Event) {
		const inputElement = event.target as HTMLInputElement
		const files: Array<File> = Array.from(inputElement?.files || [])
		const notLoadedFilesNames: Array<string> = [];

		if (files.length > 0) {
			for (const file of files) {
				const filePreview: FilePreview = await this.#tools.buildFilePreview(file)

				if (this.#isValidFileExtension(file)) {
					this.files.update((previous) => [...previous, file])
					this.filesPreview.update((previous) => [...previous, filePreview])
				} else {
					notLoadedFilesNames.push(file.name)
				}
			}
		}

		if (notLoadedFilesNames.length > 0) {
			console.error('Los siguientes archivos no fueron cargados: ', notLoadedFilesNames, ' formato incorrecto');
		}
	}

	#isValidFileExtension(file: File) {
		const extension = file.name.split('.').pop()?.toLowerCase();

		return this.allowedFileExtensions.includes(extension || '');
	}
}
